import { X, FileText } from 'lucide-react';

interface ChatFilePreviewProps {
  files: File[];
  onRemove: (index: number) => void;
}

export function ChatFilePreview({ files, onRemove }: ChatFilePreviewProps) {
  if (files.length === 0) return null;

  return (
    <div className="flex gap-2 px-2 py-1.5 overflow-x-auto">
      {files.map((file, i) => {
        const isImage = file.type.startsWith('image/');
        return (
          <div key={`${file.name}-${i}`} className="relative group shrink-0 w-16 h-16 rounded-md border bg-muted overflow-hidden">
            {isImage ? (
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
                className="w-full h-full object-cover"
                onLoad={(e) => URL.revokeObjectURL((e.target as HTMLImageElement).src)}
              />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center p-1">
                <FileText className="h-5 w-5 text-muted-foreground" />
                <span className="text-[9px] text-muted-foreground truncate w-full text-center mt-0.5">
                  {file.name.split('.').pop()?.toUpperCase()}
                </span>
              </div>
            )}
            <button
              type="button"
              onClick={() => onRemove(i)}
              className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-destructive text-destructive-foreground flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <X className="h-2.5 w-2.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
